import { useMasterData } from "@/hooks";
import { Label, MultiSelectDropdown } from "@monsterindia/global-ui-components";
import React, { memo } from "react";
import { Controller } from "react-hook-form";

import { DropdownOptionType, MultiDropDownControllerProps } from "../types";

const MultiDropDownController = ({
  name,
  type = "",
  label,
  options = [],
  control,
  onSelect,
  placeholder,
  errorMessage,
  maxSelect,
  isDisabled = false,
  isRequired = false,
  isSearchable,
  isLoading,
  suggestedOptions,
  rawText = false,
}: MultiDropDownControllerProps<any>) => {
  const {
    masterData,
    getMasterData,
    isLoading: isMasterDataLoading,
  } = useMasterData();
  const loading = isLoading ?? isMasterDataLoading;

  return (
    <Label labelText={label} isRequired={isRequired} className="w-full text-sm">
      <Controller
        name={name}
        control={control}
        rules={isRequired ? { required: "This field is required" } : undefined}
        render={({ field }) => {
          return (
            <MultiSelectDropdown
              {...field}
              id={name}
              width="w-full"
              options={options.length ? options : (masterData ?? [])}
              className="flex w-full flex-row"
              loadingText={loading ? "Loading..." : "No options available"}
              placeholder={placeholder}
              {...(!options.length && {
                onChangeHandler: async (inputText: string) =>
                  getMasterData(type, inputText),
              })}
              isSearchable={isSearchable ?? false}
              maxSelect={maxSelect}
              selectedValues={field.value ?? []}
              handleDropdownSelect={(selected: DropdownOptionType) => {
                field.onChange(selected);
                onSelect(selected);
              }}
              disabled={isDisabled}
              errorText={errorMessage}
              {...(suggestedOptions?.list?.length && {
                popularOptions: suggestedOptions,
              })}
              rawText={rawText}
            />
          );
        }}
      />
    </Label>
  );
};

export default memo(MultiDropDownController);
